import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when the retailer dismisses the FD Marketplace Discount next session modal *
 */
export const FD_MARKETPLACE_DISCOUNT_MODAL_DISMISSED =
  'FD_MARKETPLACE_DISCOUNT_MODAL_DISMISSED' as IUserMilestone.RetailerMilestone;
